module.exports = __webpack_public_path__ + "img/fill_main2.ec343770.png";